export const Handbook = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_293_24365)">
      <path
        d="M11.6665 0H2.9165C1.95167 0 1.1665 0.785167 1.1665 1.75V12.25C1.1665 13.2148 1.95167 14 2.9165 14H12.8332V1.16667C12.8332 0.52325 12.3099 0 11.6665 0ZM11.6665 10.5H4.6665V1.16667H6.99984V6.41667L8.45817 4.95833L9.9165 6.41667V1.16667H11.6665V10.5ZM2.9165 1.16667H3.49984V10.5H2.9165C2.71175 10.5 2.51575 10.5356 2.33317 10.6003V1.75C2.33317 1.42858 2.59509 1.16667 2.9165 1.16667ZM2.9165 12.8333C2.59509 12.8333 2.33317 12.5714 2.33317 12.25C2.33317 11.9286 2.59509 11.6667 2.9165 11.6667H11.6665V12.8333H2.9165Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_293_24365">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
